module.exports = __webpack_public_path__ + "static/media/close.b85858f5.svg";